import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  loading: false,
  token: null,
  expires: null,
  error: null,
};

const verifyOTPStart = (state) => (
  updateObject(state, {
    loading: true,
    token: null,
    expires: null,
    error: null,
  })
);

const verifyOTPSuccess = (state, action) => (
  updateObject(state, {
    loading: false,
    token: action.token,
    expires: new Date(action.expires),
  })
);

const verifyOTPFail = (state, action) => (
  updateObject(state, {
    loading: false,
    error: action.error,
  })
);

const reducer = (state = initialState, action = null) => {
  switch (action.type) {
    case actionTypes.VERIFY_OTP_START:
      return verifyOTPStart(state);
    case actionTypes.VERIFY_OTP_SUCCESS:
      return verifyOTPSuccess(state, action);
    case actionTypes.VERIFY_OTP_FAIL:
      return verifyOTPFail(state, action);
    case actionTypes.VERIFY_OTP_RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
